export default __webpack_public_path__ + "static/media/classComp-after-click-log.83f00674.png";